<template>
  <div class="shows" @click="apply">
      <div id="floor_div">
        <div id="lefticon">
          <img src="https://s.cyol.com/themes/cyolwap/assets/images/app/logo.png" alt="">
          <p>
            <span>更多精彩,</span>
            <span>请下载中青报客户端</span>
          </p>
        </div>
        <div id="downloadicon"> 
           <a class="dl"  id="isWX2">      
              <img src="https://s.cyol.com/themes/cyolwap/assets/images/app/download.png">
           </a>                
        </div>
      </div>
  </div>
</template>
<script>
export default {
  name: 'Footer',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  methods:{
    apply(){
      let page = btoa("pages/main/index")
      var urlShare = `cyol://news.cyol.com/share?content_type=min_program/redirect_type=default/min_program=__UNI__0BB6A9F/page=${page}/post_id=3nG702i0`;
      location.href='http://a.app.qq.com/o/simple.jsp?pkgname=com.hzpd.zqzx&ios_scheme='+encodeURI(urlShare)+'&android_scheme='+encodeURI(urlShare);
    }
  }
}
</script>

<style  scoped> 
.shows{position: fixed;  left: 0;   bottom: 0;   width: 100%;   height: 112px;background: #fff;z-index: 999999999999;border-top:1px solid #E2E2E2;}
.shows #floor_div{width: 100%;height: 100%;display: flex;justify-content: space-between;align-items: center;padding:0px 0px;}
.shows #lefticon {   display: flex;   justify-content: space-between;  align-items: center;margin-left:30px;}
.shows #lefticon img {    display: block;    width: 136px;   margin-right: 24px;}
.shows #lefticon p span {    color: #666666;    font-size: 26px;    display: block; line-height: 34px;}
.shows #downloadicon{margin-right: 30px;}
.shows #downloadicon .dl {    display: block;    width: 144px;    height: 54px;}
.shows #downloadicon .dl img{width:100%;height:100%;vertical-align:middle;}
</style>